import React from "react";
import { Home, Store } from "lucide-react";

interface NavigationButtonsProps {
  lojasCount: number;
  onGoHome?: () => void;
  onToggleLojaSelector?: () => void;
  showLojaButton?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  lojasCount,
  onGoHome,
  onToggleLojaSelector,
  showLojaButton = true,
}) => {
  return (
    <div className="fixed left-4 top-4 z-40 flex gap-2">
      <button
        type="button"
        onClick={onGoHome}
        className="rounded-full bg-black/20 p-2 opacity-50 backdrop-blur-sm transition-all duration-200 hover:bg-black/40 hover:opacity-100"
        title="Voltar ao início"
      >
        <Home size={20} className="text-white" />
      </button>
      {showLojaButton && lojasCount > 0 && (
        <button
          type="button"
          onClick={onToggleLojaSelector}
          className="rounded-full bg-black/20 p-2 opacity-50 backdrop-blur-sm transition-all duration-200 hover:bg-black/40 hover:opacity-100"
          title="Selecionar loja"
        >
          <Store size={20} className="text-white" />
        </button>
      )}
    </div>
  );
};
